function SectionTitle({ title, measure, isLast, isFirst }) {
    return (
        <div className={`w-[180px] shrink-0 flex items-center justify-center text-nowrap font-normal text-[16px] leading-[22px] text-[#666666] px-6 py-3 border-l border-t border-b border-[#EAEAEA] ${isLast && 'border-r rounded-tr-lg'} ${isFirst && 'rounded-tl-lg'}`}>
            {title} &#40;{measure}&#41;
        </div>
    );
}

export default SectionTitle;
